module.exports = ".user {\n  font-family: QuicksandRegular;\n}\n"